import { Component } from '@angular/core';

@Component({
  selector: 'app-popover-showcase',
  templateUrl: './popover-showcase.component.html',
  styleUrls: ['./popover-showcase.component.scss']
})
export class PopoverShowcaseComponent {
  manualPopoverVisible = false;

  menuItems = [
    { id: 1, name: 'Edit Profile' },
    { id: 2, name: 'Settings' },
    { id: 3, name: 'Help' },
    { id: 4, name: 'Logout' }
  ];

  notificationItems = [
    { id: 1, message: 'You have a new message', time: '2 minutes ago' },
    { id: 2, message: 'System update completed', time: '1 hour ago' },
    { id: 3, message: 'New feature released', time: '3 hours ago' }
  ];

  selectedMenu: any = null;
  selectedCheckboxes: any[] = [];

  onMenuSelect(item: any): void {
    this.selectedMenu = item;
  }

  onCheckboxChange(items: any[]): void {
    this.selectedCheckboxes = items;
  }

  toggleManualPopover(): void {
    this.manualPopoverVisible = !this.manualPopoverVisible;
  }

  getSelectedMenuLabel(): string {
    return this.selectedMenu ? this.selectedMenu.name : 'Select an option';
  }

  getSelectedCheckboxCount(): number {
    return this.selectedCheckboxes.length;
  }
}
